<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            :color="color"
            title="Categories"
            text="A table of Categories"
          >
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <base-button
                      :color="color"
                      dark
                      class="mb-2"
                      v-on="on">
                      New Category
                    </base-button>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="search"
                      :loading="loading"
                      append-icon="search"
                      label="Search"
                      hide-details/>
                  </v-flex>
                </v-layout>
              </template>
              <v-card>
                <v-card-text>
                  <v-container grid-list-md >
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.id"
                          label="Category Id" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.name"
                          label="Category Name" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12>
                        <v-textarea
                          :rules="[rules.max256chars]"
                          v-model="editedItem.description"
                          label="Description" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="editedItem.display_order"
                          type="number"
                          label="Display Order" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-checkbox
                          v-model="editedItem.active"
                          class="float-right"
                          label="Active"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />

                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="close">Cancel</v-btn>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="CategoryList"
              :pagination.sync="pagination"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">

                  <td>{{ props.item.id }}</td>
                  <td>
                    {{ props.item.name }}
                  </td>

                  <td>
                    {{ props.item.description }}
                  </td>

                  <td>
                    {{ props.item.display_order }}
                  </td>
                  <td> <v-icon v-if="props.item.active">check</v-icon></td>
                  <td class="justify-center ">
                    <i
                      class="tim-icons icon-pencil pointer"
                      @click="editItem(props.item)"/>
                    &nbsp;&nbsp;
                    <i
                      class="tim-icons icon-trash-simple pointer"
                      @click="deleteItem(props.item)"/>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    rules: {
      required: value => !!value || 'Required.',
      max256chars: v => v.length <= 256 || 'Input too long!'
    },
    pagination: {
      sortBy: 'display_order'
    },
    CategoryList: [

    ],
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Id',
        align: 'left',
        value: 'id'
      },
      {
        text: 'Name',
        align: 'left',
        value: 'name'
      },
      {
        text: 'Description',
        align: 'left',
        value: 'description'
      },
      {
        text: 'Display Order',
        align: 'left',
        value: 'display_order'
      },
      {
        text: 'Active',
        align: 'left',
        value: 'active'
      },
      {
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      description: '',
      active: true
    },
    defaultItem: {
      id: '',
      name: '',
      description: '',
      active: true
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Category' : 'Edit Category'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    // this.$store.dispatch('autoRefreshToken')
  },

  methods: {
    index () {
      this.loading = true
      let self = this
      axios.get('/categories')
        .then(response => {
          self.CategoryList = response.data
          self.loading = false
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          self.loading = false
        })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.CategoryList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.CategoryList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true
        axios.delete('/categories/' + item.id)
          .then((response) => {
            this.CategoryList.splice(index, 1)
            this.deleteInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/categories/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.CategoryList[this.editedIndex], response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true
        axios.post('/categories', this.editedItem)
          .then((response) => {
            this.CategoryList.unshift(response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Category saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Category deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
